import React from 'react';
import './Modal.css';

const Modal = ({ 
  title, 
  children, 
  actions,
  className = '',
  onClose
}) => {
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget && onClose) {
      onClose();
    }
  };

  return (
    <div className="modal-container" onClick={handleBackdropClick}>
      <div className={`modal ${className}`} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{title}</h2>
          {onClose && (
            <button className="close-btn" onClick={onClose} aria-label="Fermer">
              <i className="fas fa-times"></i>
            </button>
          )}
        </div>
        <div className="modal-content">
          {children}
        </div>
        {actions && (
          <div className="modal-actions">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal; 